/**
 * Rococo Price Manager v2
 * Gestisce l'aggiornamento del prezzo sulla pagina prodotto in modo più robusto.
 */
(function() {
  'use strict';

  const SURCHARGE_PRODUCT_HANDLE = 'colore-personalizzato-rococo';

  class RococoPriceManager {
    constructor() {
      this.surchargePrices = {}; // { variantId: priceInCents }
      this.pricesLoaded = false;
      this.basePrice = 0;
      this.currentSurcharge = 0;
      this.priceElement = null;
      this.currencyFormatter = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
    }

    async init() {
      // VERIFICA: Attivati solo se il selettore Rococò è presente nella pagina
      if (!document.querySelector('rococo-color-selector')) {
        return;
      }

      await this.fetchSurchargePrices();
      
      // Trova l'elemento del prezzo una volta
      this.priceElement = this.findPriceElement();
      if (!this.priceElement) {
        console.error('[Rococo Price] Elemento del prezzo non trovato. L\'aggiornamento non funzionerà.');
        return;
      }

      // Ascolta l'evento di cambio variante globale del tema
      document.addEventListener('variant:change', (event) => {
        if (event.detail.variant) {
          this.setBasePrice(event.detail.variant.price);
        }
      });

      // Imposta il prezzo base iniziale
      try {
        const initialVariantJson = document.querySelector('script[data-selected-variant]')?.textContent;
        if (initialVariantJson) {
          const initialVariant = JSON.parse(initialVariantJson);
          this.setBasePrice(initialVariant.price);
        }
      } catch (e) {
        console.error('[Rococo Price] Errore nel leggere la variante iniziale.', e);
        this.setBasePrice(0); // Fallback
      }
    }

    findPriceElement() {
        // Selettori più specifici e comuni per i temi Shopify
        return document.querySelector('#price-template--26378155262338__main .price-item--regular') ||
               document.querySelector('.product-price .price-item--regular') ||
               document.querySelector('.price__regular .price-item') ||
               document.querySelector('.price-item');
    }

    async fetchSurchargePrices() {
      if (this.pricesLoaded) return;
      try {
        const response = await fetch(`/products/${SURCHARGE_PRODUCT_HANDLE}.js`);
        if (!response.ok) throw new Error('Prodotto sovrapprezzo non trovato');
        const product = await response.json();
        product.variants.forEach(variant => {
          this.surchargePrices[variant.id] = variant.price;
        });
        this.pricesLoaded = true;
      } catch (error) {
        console.error('[Rococo Price] Errore caricamento prezzi sovrapprezzo:', error);
      }
    }

    setBasePrice(priceInCents) {
      this.basePrice = priceInCents || 0;
      this.applyPrice(); // Riapplica il sovrapprezzo corrente con il nuovo prezzo base
    }

    updateSurcharge(surchargeVariantId) {
      this.currentSurcharge = this.surchargePrices[surchargeVariantId] || 0;
      this.applyPrice();
    }

    resetSurcharge() {
      this.currentSurcharge = 0;
      this.applyPrice();
    }

    applyPrice() {
      if (!this.priceElement) return;
      
      const finalPrice = this.basePrice + this.currentSurcharge;
      this.priceElement.innerText = this.currencyFormatter.format(finalPrice / 100);

      // Aggiorna anche il contenitore `data-value` se esiste, per coerenza
      const priceContainer = this.priceElement.closest('.price[data-value]');
      if (priceContainer) {
        priceContainer.dataset.value = finalPrice;
      }
    }
  }

  window.RococoPriceManager = new RococoPriceManager();
  // Inizializza subito dopo la definizione
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    window.RococoPriceManager.init();
  } else {
    document.addEventListener('DOMContentLoaded', () => window.RococoPriceManager.init());
  }

})();
